<template>
  <div class="comment-page">


    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item>
          <el-input v-model="searchForm.content" placeholder="请输入评论内容" clearable prefix-icon="el-icon-search"
            style="width: 280px" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            查询
          </el-button>

          <el-button icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>

          <el-button type="primary" @click="batchDisplayHide(0)">
            批量展示
          </el-button>
          <el-button type="primary" @click="batchDisplayHide(1)">
            批量隐藏
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 评论列表 -->
    <el-card class="table-card" shadow="never">
      <!-- <div class="table-header">
        <div class="table-title">
          评论列表
        </div>

        <div class="table-total">
          共 {{ total }} 条评论
        </div>
      </div> -->

      <el-table :data="tableData" v-loading="loading" border class="comment-table" @selection-change="setSelectRows">
        <!-- 多选 -->
        <el-table-column type="selection" width="55" align="center" />
        <!-- 用户 -->
        <el-table-column label="用户" width="220">
          <template slot-scope="{ row }">
            <div class="user-info">
              <el-image class="user-avatar" :src="row.user && row.user.pic" fit="cover">
                <div slot="error" class="image-error">
                  <i class="el-icon-user"></i>
                </div>
              </el-image>
              <div class="user-detail">
                <div class="user-name">
                  {{ row.user && row.user.nickname ? row.user.nickname : '-' }}
                </div>
                <div class="user-id">
                  用户编号： {{ row.user && row.user.code ? row.user.code : '-' }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 评论内容 -->
        <el-table-column label="心愿单" min-width="460">
          <template slot-scope="{ row }">
            <div class="comment-content">
              <!-- 用户评论文字 -->
              <div class="comment-text">
                {{ row.content || '-' }}
              </div>
              <!-- 用户评论图片 -->
              <div v-if="getImageList(row.pic).length" class="comment-images">
                <el-image v-for="(img, index) in getImageList(row.pic)" :key="index" class="comment-image" :src="img"
                  :preview-src-list="getImageList(row.pic)" fit="cover" />
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 点赞数 -->
        <el-table-column label="点赞数" min-width="150">
          <template slot-scope="{ row }">
            {{ row.like_num }}
          </template>
        </el-table-column>
        <el-table-column label="展示状态" width="180">
          <template slot-scope="{ row }">
            {{ row.status == 1 ? '隐藏' : '正常' }}
          </template>
        </el-table-column>
        <!-- 上传时间 -->
        <el-table-column label="上传时间" width="180" prop="add_time" />
        <!-- 操作 -->
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="orderCommentDel(row)" style="color: red;">
              删除
            </el-button>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
          :page-size="searchForm.limit" :current-page="searchForm.page" :page-sizes="[10, 20, 30, 50]"
          @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>

    </el-card>

  </div>
</template>

<script>
import {
  Wishlist_lsit,
  Wishlist_del,
  wishlist_status_update
} from '@/api/xgcApi'

import uploadFile from '@/components/uploadFileSpecification'

export default {
  name: 'CommentManage',

  components: {
    uploadFile
  },

  data() {
    return {
      // 列表加载
      loading: false,

      // 回复提交加载
      replyLoading: false,

      // 总条数
      total: 0,

      // 查询参数
      searchForm: {
        page: 1,
        limit: 10,
        content: ''
      },
      // 表格数据
      tableData: [],
      selectRows: [],
      // 回复弹窗
      replyDialogVisible: false,

      // 当前评论
      currentComment: null,

      // 回复表单
      replyForm: {
        content: '',
        pic: ''
      },

      // 回复校验
      replyRules: {
        content: [
          {
            required: true,
            message: '请输入回复内容',
            trigger: 'blur'
          }
        ]
      }
    }
  },

  created() {
    this.getCommentList()
  },

  methods: {
    // 批量展示// 批量隐藏
    batchDisplayHide(type) {
      if (this.selectRows.length > 0) {
        const ids = this.selectRows.map((item) => item.id).join()
        this.$baseConfirm(type == 0 ? '确定进行批量展示操作？' : '确定进行批量隐藏操作？', null, async () => {
          const {
            msg
          } = await wishlist_status_update({
            wishlist_id: ids,
            status: type
          })
          this.$baseMessage(msg, 'success')
          this.getCommentList()
        })
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    /**
     * 获取心愿单列表
     */
    getCommentList() {
      this.loading = true
      Wishlist_lsit({
        page: this.searchForm.page,
        limit: this.searchForm.limit,
        content: this.searchForm.content
      })
        .then(res => {
          const data = res.data || {}
          this.tableData =
            data.records ||
            data.rows ||
            data.list ||
            res.rows ||
            []

          this.total =
            data.total ||
            res.total ||
            0
        })
        .catch(() => {
          this.tableData = []
          this.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * 处理图片地址
     *
     * 兼容：
     * 1. 单张URL
     * 2. 逗号分隔URL
     * 3. JSON数组字符串
     * 4. 数组
     */
    getImageList(pic) {
      if (!pic) {
        return []
      }

      // 数组
      if (Array.isArray(pic)) {
        return pic.filter(item => item)
      }

      // 字符串
      if (typeof pic === 'string') {
        pic = pic.trim()

        if (!pic) {
          return []
        }

        // JSON数组字符串
        try {
          const result = JSON.parse(pic)

          if (Array.isArray(result)) {
            return result.filter(item => item)
          }
        } catch (e) {
          // 普通字符串，继续处理
        }

        // 逗号分隔字符串
        return pic
          .split(',')
          .map(item => item.trim())
          .filter(item => item)
      }

      return []
    },
    // 选择行
    setSelectRows(val) {
      this.selectRows = val
    },

    /**
     * 查询
     */
    handleSearch() {
      this.searchForm.page = 1
      this.getCommentList()
    },

    /**
     * 重置
     */
    handleReset() {
      this.searchForm.content = ''
      this.searchForm.page = 1
      this.getCommentList()
    },

    /**
     * 页码改变
     */
    handlePageChange(page) {
      this.searchForm.page = page
      this.getCommentList()
    },

    /**
     * 每页条数改变
     */
    handleSizeChange(size) {
      this.searchForm.limit = size
      this.searchForm.page = 1
      this.getCommentList()
    },

    /**
         * 删除评价
         */
    orderCommentDel(row) {
      this.$confirm('此操作将永久删除该心愿单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Wishlist_del({ wish_id: row.id, }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          // 刷新列表
          this.getCommentList()
        })

      }).catch(() => {
      });
    },





  }
}
</script>

<style scoped>
.comment-page {
  min-height: 100%;
  padding: 24px;
  background: #f5f7fa;
}

/* 页面头部 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 22px;
  font-weight: 600;
  color: #303133;
  line-height: 32px;
}

.page-desc {
  margin-top: 6px;
  font-size: 13px;
  color: #909399;
}

/* 搜索卡片 */
.search-card {
  margin-bottom: 16px;
  border-radius: 6px;
}

.search-form {
  margin-bottom: -18px;
}

/* 表格卡片 */
.table-card {
  border-radius: 6px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.table-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.table-total {
  font-size: 13px;
  color: #909399;
}

/* 用户信息 */
.user-info {
  display: flex;
  align-items: center;
}

.user-avatar {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
}

.user-avatar ::v-deep img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.user-detail {
  margin-left: 10px;
  overflow: hidden;
}

.user-name {
  font-size: 14px;
  color: #303133;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-id {
  font-size: 12px;
  color: #a8abb2;
}

/* 评论内容 */
.comment-content {
  padding: 4px 0;
}

.comment-text {
  color: #303133;
  line-height: 22px;
  font-size: 14px;
  word-break: break-all;
}

.comment-source {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}

.comment-source span {
  color: #409eff;
}

/* 图片 */
.comment-images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.comment-image {
  width: 64px;
  height: 64px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  cursor: pointer;
  background: #f5f7fa;
}

.comment-image ::v-deep img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 回复区域 */
.reply-preview {
  margin-top: 12px;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  color: #606266;
  font-size: 12px;
  line-height: 22px;
}

.reply-item {
  padding: 4px 0;
  word-break: break-all;
}

.reply-item+.reply-item {
  border-top: 1px solid #ebeef5;
  margin-top: 6px;
  padding-top: 8px;
}

.reply-text {
  line-height: 22px;
}

.reply-label {
  color: #67c23a;
  font-weight: 500;
  margin-right: 4px;
}

.user-reply-label {
  color: #409eff;
}

.reply-images {
  margin-top: 8px;
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

/* 弹窗 */
.reply-dialog-content {
  padding: 0 4px;
}

.dialog-user {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
}

.dialog-avatar {
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
}

.dialog-avatar ::v-deep img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.dialog-user-info {
  margin-left: 12px;
}

.dialog-user-name {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 6px;
}

.dialog-user-code {
  color: #909399;
  font-size: 12px;
}

/* 原评论 */
.original-comment {
  margin-bottom: 22px;
}

.section-label {
  margin-bottom: 10px;
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.original-content {
  padding: 14px 16px;
  background: #f5f7fa;
  border-radius: 5px;
  color: #606266;
  line-height: 24px;
  font-size: 14px;
}

.original-text {
  word-break: break-all;
}

/* 上传 */
.upload-form-item {
  margin-top: 8px;
}

.upload-tip {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
}

.image-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  background: #f5f7fa;
  font-size: 20px;
}
</style>